import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Harga from "@/pages/Harga";
import Payment from "@/pages/Payment";
import AdminShell from "@/pages/AdminShell";
import Dashboard from "@/pages/Dashboard";
import MediaLibrary from "@/pages/MediaLibrary";
import Layouts from "@/pages/Layouts";
import Schedules from "@/pages/Schedules";
import Devices from "@/pages/Devices";
import Player from "@/pages/Player";
import Pair from "@/pages/Pair";
import Properties from "@/pages/Properties";
import ManageUsers from "@/pages/ManageUsers";
import BotAssistant from "@/pages/BotAssistant";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const [trialRedirect, setTrialRedirect] = useState(null);

  useEffect(() => {
    let mounted = true;
    if (user && user !== false) {
      api.get("/auth/trial-info").then(({ data }) => {
        if (mounted && data?.is_trial && data?.expired) {
          setTrialRedirect(true);
        }
      }).catch(() => {});
    }
    return () => { mounted = false; };
  }, [user]);

  if (loading || user === null) {
    return (
      <div className="h-screen flex items-center justify-center text-zinc-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Redirect ke halaman login dengan notice trial expired
  if (trialRedirect) return <Navigate to="/login?expired=trial" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/harga" element={<Harga />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/pair" element={<Pair />} />
          <Route path="/player" element={<Player />} />
          <Route
            path="/admin"
            element={
              <Protected>
                <AdminShell />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="media" element={<MediaLibrary />} />
            <Route path="layouts" element={<Layouts />} />
            <Route path="schedules" element={<Schedules />} />
            <Route path="devices" element={<Devices />} />
            <Route path="bot" element={<BotAssistant />} />
            <Route path="properties" element={<Properties />} />
            <Route path="users" element={<ManageUsers />} />
          </Route>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
